var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAvalanche96(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 84,
    viewBox: "0 0 84 84",
    width: 84,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    fill: "#e84142",
    r: 42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m179.395 101.809c1.455-2.513 3.8-2.513 5.258 0l9.061 15.907c1.455 2.513.265 4.564-2.646 4.564h-18.255c-2.877 0-4.068-2.05-2.646-4.564zm-17.528-30.624c1.455-2.513 3.77-2.513 5.225 0l2.017 3.638 4.762 8.367a8.693 8.693 0 0 1 0 7.573l-15.971 27.681a8.4 8.4 0 0 1 -6.548 3.836h-13.263c-2.91 0-4.1-2.017-2.646-4.564z",
    fill: "#fff",
    transform: "translate(-122.58 -58.717)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvalanche96);
export default __webpack_public_path__ + "static/media/ic_avalanche_96.b6255c50bf72e2b278fd0d1e158d60e4.svg";
export { ForwardRef as ReactComponent };